module.exports = __webpack_public_path__ + "img/cardano.c5f0b8ec.svg";